<template>
    <span v-if="error">{{error.message}}</span>
</template>

<script>
    export default {
        name: "ErrorMessage",
        props: {
            error: Object
        }
    }
</script>
